import { SendMsgPlatformList } from "../../types/eend-msg-platforms.type";

export function isSendOtpCodeApiResponseValid(response: any): boolean {

    if (!response) return false;

    if (typeof response.mobileOrEmailForGUI === "string" &&
        typeof response.sendVia === "string" && 
        SendMsgPlatformList.includes(response.sendVia)) {
        return true;
    }

    return false;
}

export function isCheckOtpCodeApiResponseValid(response: any): boolean {

    if (!response) return false;

    if (typeof response.status !== "string" ||
        typeof response.message !== "string" ||
        typeof response.data !== "object" ||
        typeof response.data.isOtpCodeValid !== "boolean"
    ) {
        return false;
    }

    return true;
}

export function isCheckRequestStatusOtpApiResponseValid(response: any): boolean {

    if (!response) return false;

    if (typeof response.status !== "string" ||
        typeof response.message !== "string" ||
        typeof response.data !== "object" ||
        typeof response.data.requestStatus !== "number"
    ) {
        return false;
    }

    return true;
}

export function isCancelPermitOtpApiResValid(response: any): boolean {

    if (!response) return false;

    if (typeof response.status !== "string" ||
        typeof response.message !== "string" ||
        typeof response.data !== "object" ||
        typeof response.data.permitIsCanceled !== "boolean"
    ) {
        return false;
    }

    return true;
}

export function isCheckValidationPermitOtpApiResValid(response: any): boolean {

    if (!response) return false;

    if (typeof response.status !== "string" ||
        typeof response.message !== "string" ||
        typeof response.data !== "object" ||
        typeof response.data.dateValidationPeriod !== "string"
    ) {
        return false;
    }

    return true;
}

export function isPreUpdateVehicleOtpApiResValid(response: any): boolean {

    console.log('isPreUpdateVehicleOtpApiResValid response: ', response);

    if (!response) return false;

    if (
        typeof response.endValidityDate !== "string" ||
        typeof response.colorId !== "number" ||
        typeof response.typeId !== "number" ||
        typeof response.vehicleGroupId !== "number" ||
        typeof response.vehicleNum !== "string"
    ) {
        return false;
    }

    return true;
}

export function isUpdateVehicleOtpApiResValid(response: any): boolean {

    console.log('isPreUpdateVehicleOtpApiResValid response: ', response);

    if (!response) return false;

    if (
        typeof response.requestId !== "number" 
    ) {
        return false;
    }

    return true;
}

export function isPreRenewedPermitOtpApiResValid(response: any): boolean {

    console.log('isPreRenewedPermitOtpApiResValid response: ', response);
    if (!response) return false;

    if (
        typeof response.endValidityDate !== "string" ||
        typeof response.company !== "boolean" ||
        typeof response.permitFee !== "number" ||
        typeof response.permitId !== "number" 
    ) {
        return false;
    }
    return true;
}

export function isRenewedPermitOtpApiResValid(response: any): boolean {
    
    console.log('isRenewedPermitOtpApiResValid response: ', response);

    if (!response) {
        console.error('Validation failed: response is falsy');
        return false;
    }

    if (typeof response.requestId !== "number") {
        console.error('Validation failed: requestId is not a number', response.requestId);
        return false;
    }
    if (typeof response.paymentProcessResult !== "object") {
        console.error('Validation failed: paymentProcessResult is not an object', response.paymentProcessResult);
        return false;
    }
    if (typeof response.paymentProcessResult.payentMethod !== "string") {
        console.error('Validation failed: payentMethod is not a string', response.paymentProcessResult.payentMethod);
        return false;
    }
    if (typeof response.paymentProcessResult.paymentAmount !== "number") {
        console.error('Validation failed: paymentAmount is not a number', response.paymentProcessResult.paymentAmount);
        return false;
    }
    if (typeof response.paymentProcessResult.hasReceipt !== "boolean") {
        console.error('Validation failed: hasReceipt is not a boolean', response.paymentProcessResult.hasReceipt);
        return false;
    }
    if (typeof response.paymentProcessResult.asmachta !== "string") {
        console.error('Validation failed: asmachta is not a string', response.paymentProcessResult.asmachta);
        return false;
    }
    if (typeof response.paymentProcessResult.receiptUrl !== "string") {
        console.error('Validation failed: receiptUrl is not a string', response.paymentProcessResult.receiptUrl);
        return false;
    }
    return true;
}